import { SET_PROMOS, REMOVE_PROMO, CREATE_PROMO } from '../actions/types/index';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_PROMOS:
      return action.payload;
    case REMOVE_PROMO:
      const copy = { ...state };
      const { key, activation } = action.payload;
      if (activation) {
        copy[key].expired = false;
      } else {
        copy[key].expired = true;
      }
      return copy;
    case CREATE_PROMO:
      return { ...state, [action.payload.key]: action.payload.promo };
    default:
      return state;
  }
};
